export class TabNewVehicles {
  constructor() {
    this.container = document.querySelector('.s-new-vehicles')
    if (!this.container) return

    this.initMainTabs()
    this.initSubTabs()
  }

  initMainTabs() {
    const mainTabs = this.container.querySelectorAll('.s-new-vehicles-tab-header')
    const mainTabsContent = this.container.querySelectorAll('.s-new-vehicles-tab-content')

    mainTabs.forEach(tab => {
      tab.addEventListener('click', () => {
        mainTabs.forEach(t => t.classList.remove('active'))
        mainTabsContent.forEach(content => content.classList.remove('active'))

        tab.classList.add('active')
        const target = tab.getAttribute('target')
        if (target) {
          const targetContent = this.container.querySelector(target)
          if (targetContent) {
            targetContent.classList.add('active')
            this.initSubTabsInContent(targetContent)
          }
        }
      })
    })
  }

  initSubTabs() {
    const activeMainContent = this.container.querySelector('.s-new-vehicles-tab-content.active')
    if (activeMainContent) {
      this.initSubTabsInContent(activeMainContent)
    }
  }

  initSubTabsInContent(mainContent) {
    const subTabsContainer = mainContent.querySelector('.s-new-vehicles-tab-content-sub-categories')
    if (!subTabsContainer) return

    const subTabs = subTabsContainer.querySelectorAll('.s-new-vehicles-tab-content-sub-category')
    const subTabsContent = subTabsContainer.querySelectorAll('.s-new-vehicles-tab-content-sub-category-content')

    subTabs.forEach(subTab => {
      subTab.addEventListener('click', () => {
        subTabs.forEach(t => t.classList.remove('active'))
        subTabsContent.forEach(content => content.classList.remove('active'))

        subTab.classList.add('active')
        const target = subTab.getAttribute('target')
        if (target) {
          const targetContent = subTabsContainer.querySelector(target)
          if (targetContent) {
            targetContent.classList.add('active')
          }
        }
      })
    })
  }
}

